import React, { useState } from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Checkbox, FormControlLabel, IconButton, Menu, MenuItem, Typography } from '@mui/material';

const AdditionalFilters = ({ includeResubmitted = false, onIncludeResubmittedChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (event) => {
    onIncludeResubmittedChange(event.target.checked);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <FilterAltIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          disablePadding: true,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem>
          <FormControlLabel
            control={<Checkbox checked={includeResubmitted} onChange={handleCheckboxChange} />}
            label={
              <Typography sx={{ fontSize: '0.875rem', padding: '1px' }}>Include re-submitted documents</Typography>
            }
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default AdditionalFilters;
